import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { getKeysFromLocalStorageThatMatchesPrefix, deleteFromLocalStorage } from 'js/utils/local-storage';

import Message from 'components/message/Message';
import ContentContainer from 'components/content-container/ContentContainer';
import HtmlString from 'components/html-string/HtmlString';
import Heading from 'components/heading/Heading';
import IconWarning from 'components/icon-warning/IconWarning';

import MessageCarousel from './MessageCarousel';

import { IconWarning_Theme, IMessageGlobalList } from 'source/NFR.types';

const MessageGlobalList: React.FC<IMessageGlobalList> = ({
  messageGlobals = [],
  initiallyOpen,
  prefix,
  printDescription,
  defaultPrintMessage
}) => {
  const [globalMessageContainer, setGlobalMessageContainer] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    const keysFromLocalStorage = getKeysFromLocalStorageThatMatchesPrefix(prefix ?? null);
    deleteFromLocalStorage(keysFromLocalStorage, 7, 'DAYS');

    const div = document.createElement('div');

    const body = document.body;
    body.prepend(div);
    setGlobalMessageContainer(div);
  }, [prefix]);

  return (
    <div className="message-global-list">
      {globalMessageContainer &&
        createPortal(
          <MessageCarousel messageGlobals={messageGlobals} initiallyOpen={initiallyOpen} />,
          globalMessageContainer
        )}
      <div className="message-global-list--print">
        <ContentContainer>
          <div className="message-global-list--print-line" />
          {printDescription && <p className="message-global-list--print-description">{printDescription}</p>}
          {messageGlobals?.length ? (
            messageGlobals.map(({ title, theme, message, id }, index) => (
              <div className="message-global-list--print-message" key={`${id}-${index}`}>
                <IconWarning className="message-global--icon-warning" theme={theme} />
                <div>
                  <Heading className="message-global--title" level={3}>
                    {title}
                  </Heading>
                  {message && <HtmlString {...message} />}
                </div>
              </div>
            ))
          ) : (
            <div className="message-global-list--print-message" key={defaultPrintMessage}>
              <Message text={{ text: defaultPrintMessage ?? '' }} theme={IconWarning_Theme.Gray} />
            </div>
          )}
        </ContentContainer>
      </div>
    </div>
  );
};

MessageGlobalList.displayName = 'MessageGlobalList';

export default MessageGlobalList;
